import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=beac58c2"
import script from "./PromoCodes.vue?vue&type=script&lang=js"
export * from "./PromoCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports